import { noop } from '@aloft/toolkit-shared';

import { useEffect, useState } from 'react';

import { useGoogleMapsLoader } from './useGoogleMapsLoader.ts';

export const useStreetViewService = () => {
  const [streetViewService, setStreetViewService] = useState<google.maps.StreetViewService>();

  const loader = useGoogleMapsLoader();

  useEffect(() => {
    const initialize = async () => {
      if (!loader || !streetViewService) {
        const StreetViewLibrary = await loader.importLibrary('streetView');
        setStreetViewService(new StreetViewLibrary.StreetViewService());
      }
    };

    initialize().then(noop).catch(console.error);
  }, [loader, streetViewService]);

  return streetViewService;
};
